import React from 'react'
import { PortfolioTracking } from '../../models/Portfolio';
import { Box } from '@mui/material';
import TrackStepListItem from './TrackStepListItem';
import horizontalLine from '../../assets/horizontalLine.svg'

export interface ITrackStepListProps {
    tracking: PortfolioTracking;
}

const TrackStepList: React.FC<ITrackStepListProps> = ({ tracking }) => {
    const pages = Math.floor(tracking.events.length / 4 + 3);
    return <Box display={"flex"} width={"100%"} flexDirection={"column"} alignItems={"flex-start"} gap={"20px"}>
        {[...Array(pages)].map((a, i) =>
            <Box display={"flex"} gap={"125px"} sx={{ backgroundImage: `url('${horizontalLine}')`, backgroundPosition: "center center", backgroundRepeat: "repeat-x" }} key={`traking-line-${i}`}>
                {tracking.events.slice(i * 4, i * 4 + 4).map((e) => <TrackStepListItem name={tracking.name} size={tracking.size} step={e} key={`tracking-step-${e.id}`} isActiveStep={tracking.events[tracking.events.length - 1] .id === e.id} />)}
            </Box>)}
    </Box>
}

export default TrackStepList